import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import ReusableTable from "../components/ReusableTable";
import { getApiUrl } from "../utils/api";
import "react-toastify/dist/ReactToastify.css";

const ComboOfferPage = () => {
  const UserId = "66abc123def4567890abcd12";

  const [combos, setCombos] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  /* ================= FETCH COMBOS ================= */
  const fetchCombos = async () => {
    const res = await fetch(getApiUrl("combo-list"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: UserId }),
    });
    const data = await res.json();
    if (data.success) setCombos(data.data);
  };

  useEffect(() => {
    fetchCombos();
  }, []);

  /* ================= FORM ================= */
  const formik = useFormik({
    initialValues: {
      title: "",
      minQuantity: 2,
      discountPerItem: "",
      status: 1,
      validFrom: "",
      validTo: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required(),
      minQuantity: Yup.number().min(2).required(),
      discountPerItem: Yup.number().min(1).required(),
    }),
    onSubmit: async (values) => {
      const body = { ...values, userId: UserId };
      if (editId) body.comboId = editId;

      const url = editId ? "combo-update" : "combo-add";

      const res = await fetch(getApiUrl(url), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const result = await res.json();
      if (result.success) {
        toast.success(editId ? "Updated!" : "Added!");
        setShowModal(false);
        setEditId(null);
        formik.resetForm();
        fetchCombos();
      }
    },
  });

  /* ================= TABLE ================= */
  const columns = [
    { name: "Title", selector: (r) => r.title },
    { name: "Min Items", selector: (r) => r.minQuantity },
    {
      name: "Discount",
      selector: (r) => `₹${r.discountPerItem} / item`,
    },
    {
      name: "Status",
      selector: (r) => (r.status === 1 ? "Active" : "Inactive"),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btn-warning btn-sm me-2"
            onClick={() => {
              setEditId(row._id);
              formik.setValues(row);
              setShowModal(true);
            }}
          >
            ✏️
          </button>
          <button
            className="btn btn-danger btn-sm"
            onClick={async () => {
              await fetch(getApiUrl("combo-delete"), {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ comboId: row._id }),
              });
              fetchCombos();
            }}
          >
            🗑
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <ToastContainer />
      <div className="d-flex justify-content-between mb-3">
        <h3>MIXED Combo Offers</h3>
        <button
          className="btn btn-primary"
          onClick={() => {
            setEditId(null);
            formik.resetForm();
            setShowModal(true);
          }}
        >
          + Add Combo
        </button>
      </div>

      <ReusableTable columns={columns} data={combos} />

      {showModal && (
        <div className="modal fade show" style={{ display: "block", background: "#0008" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-3">
              <form onSubmit={formik.handleSubmit}>
                <h5 className="mb-3">
                  {editId ? "Edit Combo" : "Add Combo"}
                </h5>

                <input
                  className="form-control mb-2"
                  placeholder="Combo Title"
                  name="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                />

                <input
                  className="form-control mb-2"
                  type="number"
                  name="minQuantity"
                  value={formik.values.minQuantity}
                  onChange={formik.handleChange}
                  placeholder="Minimum Items"
                />

                <input
                  className="form-control mb-2"
                  type="number"
                  name="discountPerItem"
                  value={formik.values.discountPerItem}
                  onChange={formik.handleChange}
                  placeholder="Discount per item"
                />

                <div className="text-end">
                  <button className="btn btn-secondary me-2" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-success">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ComboOfferPage;
